var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.173 13.116l9.723 3.864a.28.28 0 00.208 0l9.723-3.864a.272.272 0 00.173-.252.273.273 0 00-.173-.253l-4.226-1.68 4.226-1.678A.273.273 0 0021 9a.273.273 0 00-.173-.253L16.6 7.068l4.226-1.68A.273.273 0 0021 5.137a.272.272 0 00-.173-.252L11.104 1.02a.282.282 0 00-.208 0L1.173 4.884A.272.272 0 001 5.136c0 .111.069.211.173.253L5.4 7.068l-4.226 1.68A.273.273 0 001 9c0 .11.069.21.173.253L5.4 10.932l-4.226 1.68a.273.273 0 00-.173.252c0 .11.069.21.173.252zM11 1.566l8.984 3.57L11 8.706l-8.984-3.57L11 1.566zm-4.898 5.81a.26.26 0 00.028-.017l4.766 1.894c.067.026.141.026.208 0l4.757-1.89L19.984 9 11 12.57 2.016 9l4.086-1.623zm.036 3.85l4.758 1.89c.067.027.141.027.208 0l4.784-1.9a.269.269 0 00.083.054l4.013 1.594L11 16.434l-8.984-3.57 4.122-1.638z",
    fill: "currentColor",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
export default SvgProjects;